import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ddt-web/common';

import { CtaLinkModule } from '../cta-link/cta-link.module';
import { SimpleDcrContentDialogModule } from '../simple-dcr-content-dialog/simple-dcr-content-dialog.module';
import { CtaDialogComponent } from './cta-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		SimpleDcrContentDialogModule,
		CtaLinkModule
	],
	declarations: [CtaDialogComponent],
	exports: [CtaDialogComponent]
})
export class CtaDialogModule { }
